import React, { useState } from 'react';

import { Button, Card, Form } from 'react-bootstrap';

import ExclamationTriangle from '../../../assets/svg/ExclamationTriangle';

const CandidateAcceptedFolderComponent = (_props: any) => {
  const meetupList: string[] = [
    'aujourd’hui à 10:00 - 255 Av. du Prado, 13008 Marseille, France',
    'demain à 10:00 - 255 Av. du Prado, 13008 Marseille, France'
  ];
  const [selectedMeetup, setSelectedMeetup] = useState('0');

  return (
    <>
      <Card className="w-75 p-4 mx-auto">
        <Card.Header className="bg-white">
          <div className="title-h5">Mon dossier de location</div>
          <div className="text-muted text-start">
            Envoyez ici vos documents ainsi que ceux de vos colocataires et/ou garants.
          </div>
        </Card.Header>
        <Card.Body>
          <Form>
            <div className="d-flex flex-row justify-content-between gap-2 flex-wrap">
              <div className="subtitle-2 text-muted text-start fw-bold text-wrap w-50">Rendez-vous concerné</div>
              <Form.Group className="" controlId={'meetingDate'}>
                <Form.Select
                  value={selectedMeetup}
                  className="mb-2"
                  onChange={(e) => setSelectedMeetup(e.target.value)}
                  required
                >
                  {meetupList.map((value, i) => {
                    return (
                      <option key={'meetup-' + i} value={i}>
                        {value}
                      </option>
                    );
                  })}
                </Form.Select>
                <Form.Label className=" add-prop-Form ms-2 text-muted">
                  Sélectionnez la visite pour laquelle vous souhaitez envoyer votre dossier afin de vous assurer que
                  toutes les pièces demandées par l’agence sont présentes.
                </Form.Label>
              </Form.Group>
            </div>
            <hr className="fw-bold text-muted" />

            <div className="d-flex flex-row justify-content-between gap-2 flex-wrap">
              <div className="subtitle-2 text-muted text-start fw-bold text-wrap">Situation professionnelle</div>
              <div className="d-flex flex-column justify-content-start gap-4">
                <div className="rounded-3 peach-background mx-auto">
                  <div className="modal-body d-flex flex-row d-flex justify-content-start flex-wrap pt-2 pb-0 gap-4">
                    <ExclamationTriangle color="#E90117" w={'32'} />
                    <p className="fw-bold text-danger">
                      Nous constatons que des documents manquent pour : Vous, Votre garant n°1
                    </p>
                  </div>
                </div>
                <div className="fw-bold text-muted text-start text-wrap text-break">
                  Documents recommandés pour vous :
                </div>
              </div>
            </div>
          </Form>
        </Card.Body>
      </Card>
      <div className="w-75 mt-4 mx-auto">
        <Button variant="primary" role="button">
          Renseigner les informations
        </Button>
      </div>
    </>
  );
};

export default CandidateAcceptedFolderComponent;
